import { t } from 'i18next';
import React from 'react';
import type { StyleProp, TextStyle } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { openUrl } from '@/core/utils';
import { Text } from '@/ui';

const TERMS_URL = 'https://www.eonrides.com/legal/rental-terms';
const PRIVACY_URL = 'https://www.eonrides.com/legal/terms-privacy-policy';

interface SmsConsentDisclaimerProps {
  style?: StyleProp<TextStyle>;
}

export function SmsConsentDisclaimer({ style }: SmsConsentDisclaimerProps) {
  const { styles } = useStyles(stylesheet);

  return (
    <Text type="caption1" style={[styles.text, style]}>
      {`${t('entry.legal.consentPrefix')} `}
      <Text
        type="caption1"
        style={[styles.text, styles.link]}
        onPress={() => openUrl(PRIVACY_URL)}
      >
        {t('entry.legal.privacyPolicy')}
      </Text>
      {` ${t('entry.legal.and')} `}
      <Text
        type="caption1"
        style={[styles.text, styles.link]}
        onPress={() => openUrl(TERMS_URL)}
      >
        {t('entry.legal.termsAndConditions')}
      </Text>
      {` ${t('entry.legal.consentSuffix')}`}
    </Text>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  text: {
    color: theme.colors.text.secondary,
  },
  link: {
    textDecorationLine: 'underline',
  },
}));
